"use strict";
// Locals
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailZodSchema = exports.InvalidEmailFormatError = exports.Email = void 0;
const zod_1 = require("zod");
const Either_1 = require("./Either");
const ValueObject_1 = require("./ValueObject");
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
class Email extends ValueObject_1.ValueObject {
    get value() {
        return this.props.value;
    }
    static create(value) {
        if (!emailRegex.test(value)) {
            return (0, Either_1.failure)(new InvalidEmailFormatError());
        }
        const formattedEmail = value.toLowerCase();
        return (0, Either_1.success)(new Email({ value: formattedEmail }));
    }
}
exports.Email = Email;
class InvalidEmailFormatError extends Error {
    constructor() {
        super("Invalid Email format");
    }
}
exports.InvalidEmailFormatError = InvalidEmailFormatError;
exports.emailZodSchema = zod_1.z.string().refine((value) => {
    const emailOrError = Email.create(value);
    return emailOrError.isSuccess();
}, "Invalid Email Format");
//# sourceMappingURL=Email.js.map